import { FieldStatusEnum, ValidateFunction, isInvalidValue } from '@inv/hooks'
import { ValidateOptionsExtra } from '../../models/ElementModel/typing'
import { emailReg } from '@inv/constants'
import { transifyOptions } from '../../../utils/transify'

export const validateEmail: ValidateFunction<ValidateOptionsExtra> = ({ value }) => {
  const { i18n } = transifyOptions
  if (!isInvalidValue(value)) {
    if (emailReg.test(value)) {
      return {
        status: FieldStatusEnum.Success
      }
    } else {
      return {
        status: FieldStatusEnum.Invalid,
        content: i18n.t('invest.user_feedback.form.email_error')
      }
    }
  }

  return {
    status: FieldStatusEnum.UnCheck
  }
}
